<!--
 * @Author: your name
 * @Date: 2022-02-28 10:56:02
 * @LastEditTime: 2022-04-08 10:18:46
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \cacaclo_front_end\src\views\publish\productList\components\productList.vue
-->
<!-- 原本为Wish List  已改名Favorite Item -->
<template>
  <div v-loading="loading" class="user-wish" v-if="isPC">
      <div class="head-title">{{ $t('productList.wishList')}}</div>
      <div class="wish-head f-b-c bg-white">
        <div class="f--c">
          <el-select v-model="searchParams.countryCodeArray" multiple collapse-tags clearable :placeholder="$t('inSrock.shippingFrom')" size="small" style="width:140px;margin-right:10px;" @change="resetPage">
            <el-option v-for="item in shippingFromList" :key="item.country" :label="item.countryCn" :value="item.country" :title="item.countryCn"></el-option>
          </el-select>
          <el-select v-model="searchParams.status" clearable :placeholder="$t('productList.selectProductStatus')" size="small" style="width:200px;margin-right:10px;" @change="resetPage">
            <el-option label="Available" :value="1"></el-option>
            <el-option label="Out of Stock" :value="4"></el-option>
            <el-option label="Unavailable" :value="0"></el-option>
          </el-select>
          <el-select v-model="searchParams.published" clearable :placeholder="$t('productList.selectPublishStatus')" size="small" style="width:198px;margin-right:10px;" @change="resetPage">
            <el-option label="Unpublished" :value="false"></el-option>
            <el-option label="Published" :value="true"></el-option>
          </el-select>
          <el-input :placeholder="inputPlaceholder" style="width:360px" size="small" v-model="searchName">
            <template slot="append">
              <div>
                <el-button icon="el-icon-search" type="success" @click="resetPage"></el-button>
              </div>
            </template>
          </el-input>
          <!-- <div style="background-color: rgba(205, 212, 221, 0.22); height: 28px; width: 28px; margin-left: 10px;" class="f-c-c pointer" @click="allExport(1)">
            <i class="el-icon-download" style="font-size: 20px; color:#99C41C;"></i>
          </div> -->
        </div>
        <el-button round @click="$router.push('/publish/batchTasks')" size="small">
          <!-- <i class="iconfont icon-a-file-list-line1"></i> -->
          {{ $t('Publish.ProductList.Index.ListingQueue') }}
        </el-button>
      </div>
      <div class="wish-content bg-white">
        <div v-if="tableData.length" class="f--c">
          <el-button type="primary" size="small" style="margin-right: 10px;" @click="batchListToStore">{{ $t('productList.ListToStore')}}</el-button>
          <!-- <el-popconfirm
              :confirm-button-text='submitText'
              :cancel-button-text='cancelText'
              icon="el-icon-info"
              icon-color="red"
              :title="deleteTip1"
              @confirm="batchDelete('all')"
              v-if="tableData.length"
              >
              <el-button slot="reference" type="danger" size="small" :disabled="!selectionLength">Unfavorite</el-button>
          </el-popconfirm> -->
          <el-dropdown @command="handleCommand">
            <el-button size="small">
              {{ $t('userDesign.Remove') }}<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="1" :disabled="!selectionLength">{{ $t('productList.removeSelectedProducts') }}</el-dropdown-item>
              <el-dropdown-item :command="2">{{ $t('productList.removeunavailableProducts') }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <div v-if="selectionLength" class="f--c" style="margin-left:10px;color:#909399">
            <div style="margin-right:10px;">{{`${selectionLength} ${$t('productList.productSelected')}`}}</div>
            <div style="background-color: rgba(205, 212, 221, 0.22); height: 28px; width: 28px" class="f-c-c pointer" @click="allExport(2)" v-if="selectionLength">
              <i class="el-icon-download" style="font-size: 20px;color:#99C41C;"></i>
            </div>
          </div>
        </div>
        <div v-if="tableData.length" class="wish-table">
          <el-table
            :data="tableData"
            height="calc(100vh - 330px)"
            style="width: 100%;"
            @select="selectRow"
            row-key="kkProductId"
            ref="tableData"
            @select-all="selectAllRow"
            v-if="tableData.length"
            :cell-class-name="cellClassName"
            @sort-change="sortChange" >
              <el-table-column type="selection" width="45" :reserve-selection="true" :selectable="ischecked"></el-table-column>
              <el-table-column type="expand" width="40">
                <template slot-scope="{row}">
                  <div class="skulist f--c" v-for="t in row.countrySkuStockVOList" :key="t.skuCode">
                    <div style="min-width:280px;">SKU: <span>{{ t.skuCode }}</span></div>
                    <div style="min-width:300px;">Color/Size: <span>{{ `${t.color}/${t.size}` }}</span></div>
                    <div style="min-width:160px;" v-for="k in t.countrySkuStockVOS" :key="k.countryCode">{{ k.countryCn }}: <span>{{ k.stock }}</span></div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column :label="$t('productList.Description')" min-width="380">
                <template slot-scope="scope">
                  <div class="f" style="padding-right:40px">
                      <div style="margin: 0px 8px 0 0;">
                        <el-popover placement="right" width="280" trigger="hover">
                          <el-image  fit="cover" :src="scope.row.imgUrl" ></el-image>
                          <el-image slot="reference" :src="scope.row.imgUrl" fit="cover" style="width: 48px;height: 64px" />
                        </el-popover>
                      </div>
                      <div class="product-info f">
                        <el-tooltip effect="dark" :content="scope.row.productName" placement="top">
                            <div class="info-title ellipsis1 pointer" style="line-height:22px;" @click="tableAction('detail', scope.row)">{{ scope.row.productName }}</div>
                        </el-tooltip>
                        <!-- <div>{{ $t('productList.ItemNo') }}：{{ scope.row.spuCode }}</div>
                        <div style="color: red" v-if="scope.row.status === 0">{{ $t('productList.statusTips')}}</div> -->
                      </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="spuCode" :label="$t('productList.ItemNo')" min-width="120">
                <template slot-scope="{row}">{{ row.spuCode}}</template>
              </el-table-column>
              <el-table-column :label="$t('productList.Store')" min-width="140">
                <template slot-scope="{row}">
                  <div v-if="row.storeList.length === 1" class="f--c">
                    <img :src="platformImg(row.storeList[0].platformCode)" alt="" style="width:24px;height:24px;margin-right:4px">
                    {{ row.storeList[0].storeName }}
                  </div>
                  <el-popover
                    v-if="row.storeList.length > 1"
                    placement="bottom"
                    trigger="hover">
                    <div>
                      <div v-for="s in row.storeList" :key="s.id" class="f--c">
                        <img :src="platformImg(s.platformCode)" alt="" style="width:24px;height:24px;margin-right:4px">
                        {{ s.storeName }}
                      </div>
                    </div>
                    <div slot="reference" class="f--c">
                      <img :src="platformImg(row.storeList[0].platformCode)" alt="" style="width:24px;height:24px;margin-right:4px">
                      {{ row.storeList[0].storeName }},...
                    </div>
                  </el-popover>
                </template>
              </el-table-column>
              <el-table-column prop="stock" :label="$t('productList.Status')" min-width="110">
                <div slot-scope="{row}" class="f">
                  <div v-if="row.status === 1" class="tag-green">Available</div>
                  <div v-else-if="row.status === 0" class="tag-gray">Unavailable</div>
                  <div v-else-if="row.status === 4" class="tag-gray">Out of Stock</div>
                </div>
              </el-table-column>
              <el-table-column prop="stock" :label="$t('productList.Inventory')" sortable="custom" min-width="200">
                <template slot-scope="scope">
                  <div v-for="item in  scope.row.countryStockVOList" :key="item.countryCode">
                    {{ item.countryCn }}: {{ item.stock }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="price" :label="$t('productList.Price')" sortable="custom" min-width="100">
                <template slot-scope="scope">
                  {{ scope.row.price | numberKeepTwoDecimal}}
                </template>
              </el-table-column>
              <el-table-column :label="$t('productList.Action')" width="134">
                <template slot-scope="scope">
                  <el-link v-if="scope.row.status === 1" style="color: #99C41C;" @click="tableAction('detail', scope.row)" >{{$t('productList.Detail')}}</el-link>
                  <el-button type="text" @click="tableAction('delete', scope.row)" style="margin-left:10px;color:#F56C6C">{{ $t('userDesign.Remove') }}</el-button>
                </template>
              </el-table-column>
          </el-table>
          <div style="text-align:right;margin-top:12px" class="bg-white">
            <el-pagination
              layout="total, sizes, prev, pager, next, jumper"
              :page-sizes="[20, 50, 100, 200]"
              :total="total"
              :current-page.sync="searchParams.pageNumber"
              :page-size="searchParams.pageSize"
              @current-change="pageCurrentChange"
              @size-change="pageSizeChange"/>
          </div>
        </div>
        <div class="f--c bg-white" style="height: 600px" v-if="!tableData.length">
          <tableEmptyByParams v-if="searchContentStatus"></tableEmptyByParams>
          <tableEmpty type="product" v-else></tableEmpty>
        </div>
      </div>
      <SelectStoreToPublish ref="selectStoreToPublish" @storePublications="storePublications"></SelectStoreToPublish>
      <batchListToStoreModal ref="batchListToStoreModal" @storePublications="storePublications"></batchListToStoreModal>

      <el-dialog :visible.sync="dialogStoreUpdate.dialog" :title="dialogStoreUpdate.title" width="700">
        <div style="padding: 0 0 20px 30px">{{ dialogStoreUpdate.message }}</div>
        <div style="text-align: right;">
          <el-button @click="dialogStoreUpdate.dialog = false">Cancel</el-button>
          <el-button type="primary" @click="storeUpdate">Update</el-button>
        </div>
      </el-dialog>
  </div>
  <MTList :shippingFromList="shippingFromList" v-else></MTList>
</template>

<script>
import API from '@/api'
import tableEmpty from '@/components/common/tableEmpty.vue'
import tableEmptyByParams from '@/components/common/tableEmptyByParams.vue'
import SelectStoreToPublish from '@/components/SelectStoreToPublish.vue'
import batchListToStoreModal from './components/batchListToStoreModal'
import bus from '@/util/bus'
import MTList from './components/MTList'
import _ from 'lodash'
import { Notification } from 'element-ui'
export default {
  components: { tableEmpty, tableEmptyByParams, SelectStoreToPublish, batchListToStoreModal, MTList },
  data() {
    return {
      total: 0,
      searchParams: {
        pageNumber: 1,
        pageSize: 20,
        searchNameArrays: [],
        sortType: null,
        sort: null,
        countryCodeArray: []
      },
      searchName: undefined,
      tableData: [],
      selectionRowKey: [],
      searchContentStatus: false, // 参数是否有值
      loading: false,
      selectionLength: 0,
      // tableDataAll: []
      shippingFromList: [],
      notifyInstance: undefined,
      dialogStoreUpdate: {
        dialog: false,
        title: 'Tips',
        message: 'Update the Shopify app to list new products!',
        url: undefined
      }
    }
  },
  computed: {
    submitText() {
      return this.$t('productList.submit')
    },
    cancelText() {
      return this.$t('productList.cancel')
    },
    deleteTip1() {
      return this.$t('productList.deleteTip1')
    },
    typeObjinternational() {
      let obj = {
        1: this.$t('productList.customized'),
        2: this.$t('productList.goodsInStock')
      }
      return obj
    },
    inputPlaceholder() {
      return this.$t('productList.inputPlaceholder')
    }
  },
  created() {
    if (this.isPC) {
      bus.$on('batchPublishedSuccess', this.batchPublishedSuccess)
      this.getList()
    }
    this.getShippingFromList()
  },
  beforeDestroy() {
    this.$once('hook:beforeDestroy', () => {
      bus.$off('batchPublishedSuccess')
    })
  },
  methods: {
    ischecked(row, index) {
      if (row.countryStockVOList.some(t => t.countryCode === 'CN' && t.stock <= 0)) return false
      return row.status === 1
    },
    platformImg(code) {
      let img = ''
      switch (code) {
        case 'SP':
          img = require('@/assets/img/shopify-store.png')
          break
        case 'KA':
          img = require('@/assets/img/kakaclo-store.png')
          break
        case 'DJ':
          img = require('@/assets/img/dianjiang-store.png')
          break
        case 'SL':
          img = require('@/assets/img/shopLine-store.png')
          break
        case 'WC':
          img = require('@/assets/img/woocommerce.png')
          break
        case 'TT':
          img = require('@/assets/img/tiktok.png')
          break
      }
      return img
    },
    pageCurrentChange(page) {
      this.searchParams.pageNumber = page
      this.getList()
    },
    getList() {
      this.loading = true
      let params = Object.assign({}, this.searchParams)
      this.searchName ? params.searchNameArrays = [this.searchName] : params.searchNameArrays = []
      API.publishGetProductList(params).then(res => {
        this.tableData = res.data.list
        this.total = res.data.total
        this.searchContentStatus = !!this.searchParams.productName
        this.clearSelection()
      }).finally(() => {
        this.loading = false
      })
    },
    clearSelection() {
      this.selectionLength = 0
      this.$refs.tableData && this.$refs.tableData.clearSelection()
    },
    selectRow(selection, row) {
      if (selection.length > 100) {
        this.$refs.tableData.toggleRowSelection(row, false)
        this.$message.error(this.$t('productList.batchPublishTips'))
        this.selectionLength = selection.length - 1
      } else {
        this.selectionLength = selection.length
      }
    },
    selectAllRow(selection) {
      this.selectionLength = selection.length
    },
    resetPage() {
      this.searchParams.pageNumber = 1
      this.$refs.tableData && this.$refs.tableData.clearSelection()
      this.getList()
    },
    batchDelete(deleteType, kkProductIds) {
      // if (deleteType === 1 && !this.$refs.tableData.selection.length) return
      API.deleteProductCollects({
        kkProductIds: kkProductIds || (deleteType === 1 ? this.$refs.tableData.selection.map(e => e.kkProductId) : undefined),
        deleteType
      }).then(res => {
        this.$message.success(res.message)
        this.resetPage()
      }).catch(err => {
        let message = err.message || err.data.message
        this.$message.error(message)
      })
    },
    tableAction(type, row) {
      if (type === 'detail') {
        this.jumpDetailSeo(row.kkProductId)
      } else if (type === 'listToStore') {
        this.$refs.selectStoreToPublish.show(row.kkProductId)
      } else if (type === 'delete') {
        this.$confirm(this.deleteTip1, 'Notice', {
          confirmButtonText: this.$t('userDesign.Confirm'),
          cancelButtonText: this.$t('userDesign.Cancel'),
          type: 'warning'
        }).then(() => {
          this.batchDelete(1, [row.kkProductId])
        })
        // API.deleteProductCollects({
        //   deleteType: 1,
        //   kkProductIds: [row.kkProductId]
        // }).then(res => {
        //   this.$message.success(res.message)
        //   this.getList()
        // })
      }
    },
    cellClassName({ row }) {
      let className = row.status !== 1 ? 'anomaly-column' : ''
      return className
    },
    batchListToStore() {
      if (!this.selectionLength) {
        return this.$message.warning(this.$t('productList.Tips2'))
      }
      const spusTargets = this.$refs.tableData.selection
      if (spusTargets.length === 1) {
        this.$refs.selectStoreToPublish.show(spusTargets[0].kkProductId)
        return
      }
      if (spusTargets.every(e => e.status !== 0)) {
        const spus = spusTargets.map(e => e.spuCode)
        const spusList = []
        const spuCodes = []
        const country = this.searchParams.countryCodeArray.length ? this.shippingFromList.filter(item => this.searchParams.countryCodeArray.includes(item.countryCode)) : this.shippingFromList
        country.forEach(item => {
          let obj = {
            spu: [],
            countryCode: item.countryCode,
            countryName: item.countryCn
          }
          spusTargets.forEach(s => {
            if (s.countryStockVOList.some(c => c.countryCode === item.countryCode) && !spuCodes.includes(s.spuCode)) {
              obj.spu.push(s.spuCode)
              spuCodes.push(s.spuCode)
            }
          })
          spusList.push(obj)
        })
        let spuCountryDTOList = spusList.filter(item => item.spu.length).map(item => ({ ...item, spu: item.spu.join() }))
        this.$refs.batchListToStoreModal.show(spus, spuCountryDTOList)
      } else {
        this.$message.error(this.$t('productList.haveShelves'))
      }
    },
    listToStoreSuccess(publishedListMoreParams) {
      this.$refs.tableData.clearSelection()
      // 平台店铺存储
      this.$store.commit('published/set', { publishedListMoreParams })
    },
    batchPublishedSuccess(publishedListMoreParams) {
      // 平台店铺存储
      this.$store.commit('published/set', { publishedListMoreParams })
      this.$router.push('/publish/batchTasks')
    },
    pageSizeChange(pageSize) {
      this.searchParams.pageSize = pageSize
      this.getList()
    },
    sortChange(info) {
      const { order, prop } = info
      this.searchParams.sortType = prop === 'stock' ? 1 : 2
      if (order === 'descending') {
        this.searchParams.sort = 'desc'
      } else if (order === 'ascending') {
        this.searchParams.sort = 'asc'
      } else {
        this.searchParams.sort = null
      }
      this.getList()
    },
    getShippingFromList() {
      API.getShippingFromList({ pageNumber: 1, pageSize: 20 }).then(res => {
        this.shippingFromList = _.unionBy(res.data.list, 'countryCode')
      })
    },
    handleCommand(command) {
      this.$confirm(command === 1 ? this.deleteTip1 : this.$t('productList.Tips1'), 'Notice', {
        confirmButtonText: this.$t('userDesign.Confirm'),
        cancelButtonText: this.$t('userDesign.Cancel'),
        type: 'warning'
      }).then(() => {
        this.batchDelete(command)
      })
    },
    allExport(type) {
      const params = {
        fileType: 2,
        taskType: 26
      }
      if (type === 1) {
        let searchParams = _.cloneDeep(this.searchParams)
        delete searchParams.pageNumber
        delete searchParams.pageSize
        params.condition = JSON.stringify(searchParams)
      } else {
        if (!this.selectionLength) return
        params.condition = JSON.stringify({ ids: this.$refs.tableData.selection.map((e) => e.id) })
      }
      this.loadingContainer = this.$loading.service({
        text: 'Produc Exporting , Please wait'
      })
      const that = this
      this.exportType = type
      API.importExportFile(params).then((res) => {
        this.loadingContainer.close()
        this.$refs.tableData.clearSelection()
        if (res.code !== 10000) return this.$message.error(res.message)
        // Clear the selectionLength
        this.selectionLength = 0
        // this.$confirm(`提示`, {
        //   confirmButtonText: `打开通知`,
        //   cancelButtonText: `取消`,
        //   type: 'warning'
        // }).then(() => {
        //   bus.$emit('favoriteExportList')
        // })
        const h = this.$createElement
        this.notifyInstance = Notification({
          title: 'Export task creation completed',
          message: h('el-button', { style: 'margin-top:10px;padding:8px 10px 6px 10px;position: relative;left:180px', on: { click: this.favoriteExportList }}, 'View progress'),
          duration: 5000
        })
      })
    },
    favoriteExportList() {
      bus.$emit('favoriteExportList')
      this.notifyInstance.close()
    },

    storeUpdate() {
      window.open(this.dialogStoreUpdate.url, '_blank')
    },
    storePublications(url) {
      this.dialogStoreUpdate.dialog = true
      this.dialogStoreUpdate.url = url
    }
  }
}
</script>

<style lang="scss" scoped>
.user-wish {
  padding: 20px 20px 0 36px;
  min-width: 1200px;
  color: #303133;
  .head-title {
    font-size: 20px;
    font-weight: 600;
    margin-bottom: 12px;
  }

  .wish-head {
    padding: 20px;
    margin-bottom: 12px;
  }

  .wish-content {
    height: calc(100vh - 200px);
    box-sizing: border-box;
    padding: 16px 20px;

    .head {
      margin-bottom: 16px;
    }

    .wish-table {
      margin-top: 20px;
      .skulist {
        padding: 10px 20px 10px 60px;
        color: #606266;
        border-bottom: 1px solid #EFF1F7;
        >div {
          padding-right: 20px;
        }
        &:last-child {
          border: 0;
        }
        span {
          color: #909399;
        }
      }
      .product-info {
        flex-direction: column;
        justify-content: center;
        .info-title:hover {
          text-decoration:underline;
        }
      }
      .tag-green,.tag-gray {
        display: flex;
        height: 24px;
        line-height: 26px;
        font-size: 12px;
        padding: 0 8px;
        border-radius: 2px;
      }
      .tag-green {
        background-color: #ECF8F0;
        color: #43BC65;
      }
      .tag-gray {
        background-color: #F7F8FB;
        color: #909399;
      }
    }
  }

  /deep/ .el-input__inner{
    border-radius: 2px;
  }
  /deep/ .el-input-group--append .el-input__inner {
    border-top-left-radius: 2px;
    border-bottom-left-radius: 2px;
  }
  /deep/ .el-button {
    border-radius: 2px;
  }

  /deep/ .anomaly-column {
    .el-table__expand-icon {
      display: none;
    }
  }
}
</style>
